import { render } from "./UserListPage.vue?vue&type=template&id=674d4387&ts=true"
import script from "./UserListPage.vue?vue&type=script&lang=ts"
export * from "./UserListPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__